/**
 * FilterSection Component
 * 탈퇴 요청 검색 필터 영역
 */
import React, { useMemo } from 'react';
import SearchableSelect, { SelectOption } from '@/shared/components/forms/SearchableSelect';
import { CommonCodeDto } from '@/shared/types/commonCode.types';
import { FilterState } from '../utils/userWithdrawHelpers';

// ======== 타입 ========

interface FilterSectionProps {
    filters: FilterState;
    contStatusCodes: CommonCodeDto[];
    withdrawalStatusCodes: CommonCodeDto[];
    onFilterChange: (filters: FilterState) => void;
    onSearch: () => void;
}

// ======== 컴포넌트 ========

const FilterSection: React.FC<FilterSectionProps> = ({
                                                         filters,
                                                         contStatusCodes,
                                                         withdrawalStatusCodes,
                                                         onFilterChange,
                                                         onSearch,
                                                     }) => {
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') onSearch();
    };

    const contStatusOptions: SelectOption[] = useMemo(
        () => contStatusCodes.map(c => ({ value: c.comCode, label: c.comCdName })),
        [contStatusCodes]
    );

    const withdrawalStatusOptions: SelectOption[] = useMemo(
        () => withdrawalStatusCodes.map(c => ({ value: c.comCode, label: c.comCdName })),
        [withdrawalStatusCodes]
    );

    return (
        <div className="card search-card">
            <div className="card-body">
                <div className="search-form user-withdraw-search-form">
                    {/* 라이더명 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-user" />
                                라이더명
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                placeholder="라이더명 입력..."
                                value={filters.riderName}
                                onChange={(e) => onFilterChange({ ...filters, riderName: e.target.value })}
                                onKeyDown={handleKeyDown}
                            />
                        </div>
                    </div>

                    {/* 협력사명 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-building" />
                                협력사명
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                placeholder="협력사명 입력..."
                                value={filters.suppName}
                                onChange={(e) => onFilterChange({ ...filters, suppName: e.target.value })}
                                onKeyDown={handleKeyDown}
                            />
                        </div>
                    </div>

                    {/* 계약 상태 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-file-contract" />
                                계약 상태
                            </label>
                            <SearchableSelect
                                options={contStatusOptions}
                                value={filters.contStatus}
                                onChange={(value) => onFilterChange({ ...filters, contStatus: value })}
                                placeholder="전체"
                                showAllOption={true}
                                allOptionLabel="전체"
                            />
                        </div>
                    </div>

                    {/* 탈퇴 요청 상태 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-user-minus" />
                                탈퇴 요청 상태
                            </label>
                            <SearchableSelect
                                options={withdrawalStatusOptions}
                                value={filters.withdrawalStatusCd}
                                onChange={(value) => onFilterChange({ ...filters, withdrawalStatusCd: value })}
                                placeholder="전체"
                                showAllOption={true}
                                allOptionLabel="전체"
                            />
                        </div>
                    </div>

                    {/* 버튼 그룹 */}
                    <div className="form-group button-group">
                        <button className="btn btn-primary" onClick={onSearch}>
                            <i className="fas fa-search" />
                            조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterSection;
